import { render, staticRenderFns } from "./AddToMarketplacePage.vue?vue&type=template&id=3cff2f89&scoped=true&"
import script from "./AddToMarketplacePage.vue?vue&type=script&lang=js&"
export * from "./AddToMarketplacePage.vue?vue&type=script&lang=js&"
import style0 from "./AddToMarketplacePage.vue?vue&type=style&index=0&id=3cff2f89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cff2f89",
  null
  
)

export default component.exports